module.exports = require('./lib/effects')


/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-saga/effects.js
 ** module id = ./node_modules/redux-saga/effects.js
 ** module chunks = 2
 **/